<template>
  <RfBaseModal
    ref="statusExperimentModal"
    width="700"
    :title="`${experimentToUpdate.is_active ? 'End' : 'Start'} experiment confirmation`"
  >
    <template #body>
      <RfAlert v-if="!experimentToUpdate?.is_active" type="error" class="mb-4">
        <template v-if="experimentToUpdate?.is_live_editable"
          >This experiment will be editable, which could compromise the results.</template
        >
        <template v-else>This experiment will not be editable after it starts.</template>
      </RfAlert>
      <RfAlert
        v-if="!experimentToUpdate.is_active && showPromptMessage"
        type="warning"
        class="mb-4"
      >
        Your prompt will be published.</RfAlert
      >
      <div v-if="experimentToUpdate.is_active">Are you sure you want to stop this experiment?</div>
      <div v-else>Are you sure you want to start this experiment?</div>
    </template>
    <template #actions>
      <RfButtonNew
        size="large"
        type="tertiary"
        @click="(statusExperimentModal?.close(), emit('close'))"
      >
        Close
      </RfButtonNew>
      <RfButtonNew
        v-if="experimentToUpdate.is_active"
        size="large"
        type="secondary"
        @click="emit('primary', true)"
      >
        End experiment & pause prompt
      </RfButtonNew>
      <RfButtonNew size="large" @click="emit('primary', false)">
        {{ experimentToUpdate.is_active ? "End" : "Start" }} experiment
      </RfButtonNew>
    </template>
  </RfBaseModal>
</template>

<script setup>
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfBaseModal from "@/components/modals/RfBaseModal.vue";
import RfAlert from "@/components/alerts/RfAlert.vue";
import { useTemplateRef } from "vue";

const statusExperimentModal = useTemplateRef("statusExperimentModal");
const emit = defineEmits(["primary", "close"]);
defineProps({
  experimentToUpdate: { type: Object, default: null },
  showPromptMessage: { type: Boolean, default: false },
});

defineExpose({
  show: () => statusExperimentModal.value?.show(),
  close: () => statusExperimentModal.value?.close(),
});
</script>
